export default async function ({ req, store }) {
    if (process.server && typeof req !== 'undefined') {
        await store.dispatch('checkout/setInitiativeContext', req.headers.host);
    }
}
